import { useState, useEffect } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import CalendlyModal from './components/CalendlyModal';
import CustomCursor from './components/CustomCursor';
import Hero from './sections/Hero';
import Credibility from './sections/Credibility';
import About from './sections/About';
import Experience from './sections/Experience';
import Projects from './sections/Projects';
import Skills from './sections/Skills';
import WhyMe from './sections/WhyMe';
import Contact from './sections/Contact';

function App() {
  const [calendlyOpen, setCalendlyOpen] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div
      className={`min-h-screen bg-bg-primary transition-opacity duration-500 ${
        isLoaded ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <CustomCursor />
      <Header onBookCall={() => setCalendlyOpen(true)} />
      <main>
        <Hero onBookCall={() => setCalendlyOpen(true)} />
        <Credibility />
        <About />
        <Experience />
        <Projects />
        <Skills />
        <WhyMe />
        <Contact />
      </main>
      <Footer />
      <CalendlyModal
        isOpen={calendlyOpen}
        onClose={() => setCalendlyOpen(false)}
      />
    </div>
  );
}

export default App;
